import React, { useRef } from "react";

export default function TopHeader(props) {
  // Create a ref for the marquee element
  const marqueeRef = useRef(null);

  // Function to stop the marquee
  const handleMouseOver = () => {
    if (marqueeRef.current) {
      marqueeRef.current.stop();
    }
  };

  // Function to start the marquee
  const handleMouseOut = () => {
    if (marqueeRef.current) {
      marqueeRef.current.start();
    }
  };

  return (
    <>
      <div className="top-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 text-center">
              <marquee
                ref={marqueeRef}
                width="100%"
                direction="left"
                height="auto"
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
              >
                <div className="d-flex align-items-center">
                  <div className="topEmail">
                    <a href="tel:9990031433" className="text-white decoration-none">
                    <i className="fas fa-envelope-open-text mr-2 brandText"></i>
                    {props.emailText}
                    </a>
                  </div>
                  <div className="topPhone mx-3">
                    <a href="mailto:kohliarjun823@gmail.com" className="text-white decoration-none">
                    <i className="fas fa-phone-volume mr-2 brandText"></i>
                    {props.phoneText}
                    </a>
                  </div>
                  <div className="topContent ml-3">
                    <p className="m-0">{props.topText}</p>
                  </div>
                </div>
              </marquee>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
